export default {
    props: {
        platform: { //平台: 0:用户端,2:客户经理端,3:服务师端
            type: Number,
            default: 2
        },
        userType: { //用户类型: 0|空:客户, 2:管家
            type: Number,
            default: 0
        },
        // userId: { //用户Id(极光Code)
        //     type: Number|String,
        //     default: 0
        // },
    },
    data() {
        return {
            alert: {
                isshow: false,
            },
            cityId: 310100, //this.$getCity(),
            // userType: this.$route.query.ut ? parseInt(this.$route.query.ut) : 0, //用户类型: 0|空:客户, 2:管家
            //用户Id(极光Code) 如:3524(管家14000000000) 1002(客户15221522900)
            userId: this.$route.query.uid ? this.$route.query.uid : null,
            //来源页面: 100:聊天窗口
            fromPage: this.$route.query.fromPage ? parseInt(this.$route.query.fromPage) : 0,
            isShowReleaseClientJobConfirmPanel: this.fromPage==100 ? true : false, //是否显示发布订单须知面板
            formJob: {
                workType: { //工作类型
                    id: 0,
                    value: ""
                },
                serviceType: [ //服务内容
                    {
                        id: 0,
                        value: ""
                    }
                ],
                serviceValues: "", //服务内容输出显示
                salaryRange: "", //薪资范围
                workDays: "", //工作天数
                workTimes: [ //工作时间
                    // {
                    //     TimeId: 0,
                    //     BenginTime: "",
                    //     EndTime: "",
                    //     IsDelete: false,
                    // }
                ],
                workArea: "", //工作面积
                workRegion: { //工作区域
                    id: 0,
                    value: "",
                    parentId: 310100, //this.$getCity(),
                },
                residence: "", //小区名称
                workDescription: "", //工作描述
                //更多信息
                workLife: { //工作年限
                    id: 0,
                    value: "",
                    parentId: 0,
                },
                familyNumber: "", //家庭人数
                nativePlace: "", //籍贯限制
            },
            workTimeList: [], //时间列表
            region: [], //行政区域
            // yearList: [ //工作年限列表
            //     [{
            //             id: 1,
            //             value: "不限",
            //             parentId: 0,
            //         },
            //         {
            //             id: 2,
            //             value: "1年",
            //             parentId: 0,
            //         },
            //         {
            //             id: 3,
            //             value: "2年",
            //             parentId: 0,
            //         },
            //         {
            //             id: 4,
            //             value: "3年",
            //             parentId: 0,
            //         },
            //         {
            //             id: 5,
            //             value: "4年",
            //             parentId: 0,
            //         },
            //         {
            //             id: 6,
            //             value: "5年",
            //             parentId: 0,
            //         },
            //         {
            //             id: 7,
            //             value: "6年",
            //             parentId: 0,
            //         },
            //         {
            //             id: 8,
            //             value: "7年",
            //             parentId: 0,
            //         },
            //         {
            //             id: 9,
            //             value: "8年",
            //             parentId: 0,
            //         },
            //         {
            //             id: 10,
            //             value: "9年",
            //             parentId: 0,
            //         },
            //         {
            //             id: 11,
            //             value: "10年",
            //             parentId: 0,
            //         },
            //         {
            //             id: 12,
            //             value: "10年以上",
            //             parentId: 0,
            //         },
            //     ]
            // ],
            yearList: [ //工作年限列表
                [{
                        id: 1,
                        value: "长期用工",
                        parentId: 0,
                    },
                    {
                        id: 2,
                        value: "短期用工",
                        parentId: 0,
                    },
                ]
            ],
            iosSelectRelation: [1],
            isShowWorktypePanel: false, //是否显示选择工作类型面板
            isShowServicetypePanel: false, //是否显示选择服务内容面板
            isShowRegionPanel: false, //是否显示区域面板
            isShowYearListPanel: false, //是否显示工作年限面板
            isClearField: false, //是否清空field数据
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        '$route': function(to, from) {
            if (to && to.name === 'releaseClientJob') {
                this.init();
            }
        }
    },
    methods: {
        init() {
            this.cityId = 310100; //this.$getCity();
            this.userId = this.$route.query.uid ? this.$route.query.uid : null;
            if(!this.userId || this.userId==0 || this.userId==""
            || this.userId==null || this.userId=="null" || this.userId==undefined || this.userId=="undefined"){
                this.userId = null;
            }
            this.fromPage = this.$route.query.fromPage ? parseInt(this.$route.query.fromPage) : 0;
            this.isShowReleaseClientJobConfirmPanel = this.fromPage==100 ? true : false;
            this.formJob = {
                workType: { //工作类型
                    id: 0,
                    value: ""
                },
                serviceType: [ //服务内容
                    {
                        id: 0,
                        value: ""
                    }
                ],
                serviceValues: "", //服务内容输出显示
                salaryRange: "", //薪资范围
                workDays: "", //工作天数
                workTimes: [ //工作时间
                    // {
                    //     TimeId: 0,
                    //     BenginTime: "",
                    //     EndTime: "",
                    //     IsDelete: false,
                    // }
                ],
                workArea: "", //工作面积
                workRegion: { //工作区域
                    id: 0,
                    value: "",
                    parentId: 310100, //this.$getCity(),
                },
                residence: "", //小区名称
                workDescription: "", //工作描述
                //更多信息
                workLife: { //工作年限
                    id: 0,
                    value: "",
                    parentId: 0,
                },
                familyNumber: "", //家庭人数
                nativePlace: "", //籍贯限制
            };
            this.workTimeList = []; //时间列表
            for (var i = 0; i < 24; i++) {
                this.workTimeList.push({
                    Name: i + ':00',
                    Value: i,
                    BenginTime: i + ':00',
                    EndTime: i + ':00',
                });
            }
            this.isShowWorktypePanel = false;
            this.isShowServicetypePanel = false;
            this.getRegion();
            this.isShowRegionPanel = false;
            this.isShowYearListPanel = false;
            this.isClearField = false;
        },
        //获取行政区域
        getRegion() {
            var self = this;
            self.region = [
                []
            ];
            this.$get("/query/listarea", {
                cityid: this.cityId
            }, function(result) {
                if (result && result.length > 0) {
                    result.map((item, index) => {
                        let newItem = {};
                        newItem.id = item.Id;
                        newItem.value = item.Areaname;
                        newItem.parentId = self.cityId;
                        // newItem.key = item.Areaname;
                        // newItem.Shortname = item.Shortname;
                        // if (index <= 0) {
                        //     newItem.selected = true;
                        //     self.selectedRegion = JSON.parse(JSON.stringify(newItem));
                        // } else {
                        //     newItem.selected = false;
                        // }
                        self.region[0].push(newItem);
                    });
                } else {
                    self.$toast("网络错误，请稍后再试");
                }
            });
        },

        //打开选择工作类型面板
        openWorktypePanel() {
            this.isShowWorktypePanel = true;
        },
        //修改工作类型
        chgWorktype(paramsItem) {
            this.formJob.workType = JSON.parse(JSON.stringify(paramsItem));
        },
        //关闭选择工作类型面板
        closeWorktypePanel() {
            this.isShowWorktypePanel = false;
        },

        //打开选择服务内容面板
        openServicetypePanel() {
            this.isShowServicetypePanel = true;
        },
        //修改服务内容
        chgServicetype(paramsItems) {
            let self = this;
            this.formJob.serviceType = [];
            self.formJob.serviceValues = "";
            if (paramsItems && paramsItems.length > 0) {
                paramsItems.map(item => {
                    let newItem = {};
                    newItem.id = item.SubCategoryId;
                    newItem.value = item.SubCategoryName;
                    self.formJob.serviceType.push(newItem);
                    self.formJob.serviceValues += newItem.value + " ";
                });
            } else {
                let newItem = {
                    id: 0,
                    value: ""
                };
                self.formJob.serviceType.push(newItem);
            }
        },
        //关闭选择服务内容面板
        closeServicetypePanel() {
            this.isShowServicetypePanel = false;
        },

        //即时返回FieldValue
        watchField(fieldName, backFieldValue) {
            this.formJob[fieldName] = backFieldValue;
        },

        //添加工作时间
        addWorkTime() {
            this.formJob.workTimes.push({
                TimeId: 0,
                BenginTime: "",
                EndTime: "",
                IsDelete: false,
            });
        },
        //选择工作开始时间
        checkWorkTimeStart(options) {
            //{"Name":"3:00","Value":3,"dove":"0_1"}
            if (options.dove === undefined) return;
            var doveArr = options.dove.split('_');
            this.formJob.workTimes[doveArr[1]].BenginTime = options.BenginTime;
        },
        //选择工作结束时间
        checkWorkTimeEnd(options) {
            if (options.dove === undefined) return;
            var doveArr = options.dove.split('_');
            this.formJob.workTimes[doveArr[1]].EndTime = options.EndTime;
        },
        //移除工作时间
        removeWorkTime(paramsIndex) {
            this.formJob.workTimes.splice(paramsIndex, 1);
        },

        //打开iosSelect - 区域
        openRegion() {
            if (this.region.length <= 0) {
                this.getRegion();
            }
            this.isShowRegionPanel = true;
        },
        //设置地区
        resetWorkRegion(paramsValues, paramsIds) {
            if (paramsValues) {
                this.formJob.workRegion.value = paramsValues.join("");
            } else {
                this.formJob.workRegion.value = "";
            }
            if (paramsIds && paramsIds.length > 0) {
                this.formJob.workRegion.id = parseInt(paramsIds[0]);
            } else {
                this.formJob.workRegion.id = 0;
            }
            // console.log(this.formJob.workRegion.id);
            this.closeRegion();
        },
        //关闭iosSelect - 区域
        closeRegion() {
            this.isShowRegionPanel = false;
        },

        //打开iosSelect - 工作年限
        openWorkLife() {
            this.isShowYearListPanel = true;
        },
        //设置工作年限
        resetWorkLife(paramsValues, paramsIds) {
            if (paramsValues) {
                this.formJob.workLife.value = paramsValues.join("");
            } else {
                this.formJob.workLife.value = "";
            }
            if (paramsIds && paramsIds.length > 0) {
                this.formJob.workLife.id = parseInt(paramsIds[0]);
            } else {
                this.formJob.workLife.id = 0;
            }
            // console.log(this.formJob.workLife.id);
            this.closeWorkLife();
        },
        //关闭iosSelect - 工作年限
        closeWorkLife() {
            this.isShowYearListPanel = false;
        },

        //提交
        subJob() {
            let self = this;
            let params = {
                City: this.cityId,
            };
            if (!this.formJob.workType || !this.formJob.workType.id || this.formJob.workType.id <= 0) {
                this.$toast("请选择工作类型");
                return false;
            } else if (!this.formJob.serviceType || this.formJob.serviceType.length <= 0 || this.formJob.serviceType[0].id <= 0) {
                this.$toast("请选择服务内容");
                return false;
            } else if (!this.formJob.salaryRange || this.formJob.salaryRange == "") {
                this.$toast("请输入薪资范围");
                return false;
            } else if (!this.formJob.workDays || this.formJob.workDays == "") {
                this.$toast("请输入工作天数");
                return false;
            } else if (!this.formJob.workTimes || this.formJob.workTimes.length <= 0) {
                this.$toast("请添加工作时间");
                return false;
            } else if (this.formJob.workTimes && this.formJob.workTimes.length > 0) {
                let isEffective = false;
                for (let i = 0; i < this.formJob.workTimes.length; i++) {
                    if (this.formJob.workTimes[i].BenginTime || this.formJob.workTimes[i].EndTime) {
                        isEffective = true;
                        break;
                    }
                }
                if (!isEffective) {
                    this.$toast("请添加工作时间");
                    return false;
                }
            }
            if (!this.formJob.workArea || this.formJob.workArea == "") {
                this.$toast("请输入工作面积");
                return false;
            } else if (!this.formJob.workRegion || !this.formJob.workRegion.id || this.formJob.workRegion.id <= 0) {
                this.$toast("请选择工作区域");
                return false;
            } else if (!this.formJob.residence || this.formJob.residence == "") {
                this.$toast("请输入小区名称");
                return false;
            } else if (!this.formJob.workDescription || this.formJob.workDescription == "") {
                this.$toast("请输入工作描述");
                return false;
            }
            params.JobType = this.formJob.workType.id;
            let serviceCont = [];
            this.formJob.serviceType.map(item => {
                serviceCont.push(item.id);
            });
            params.ServiceContent = serviceCont.join(",");
            params.SalaryRange = this.formJob.salaryRange;
            params.WorkDays = this.formJob.workDays;
            if (this.formJob.workTimes && this.formJob.workTimes.length > 0) {
                let newWorkTimes = [];
                this.formJob.workTimes.map(item => {
                    if (item.BenginTime || item.EndTime) {
                        let newWorkTime = {
                            WorkTimeStart: item.BenginTime,
                            WorkTimeEnd: item.EndTime
                        };
                        newWorkTimes.push(newWorkTime);
                    }
                });
                if (newWorkTimes && newWorkTimes.length > 0) {
                    params.WorkTimes = newWorkTimes;
                }
            }
            params.WorkingArea = this.formJob.workArea;
            params.AreaId = this.formJob.workRegion.id;
            params.Landmark = this.formJob.residence;
            params.Description = this.formJob.workDescription;
            params.WorkDuration = this.formJob.workLife.value;
            params.NumberOfPeople = this.formJob.familyNumber;
            params.NativePlaceLimit = this.formJob.nativePlace;
            if(self.userType && self.userType==2 && self.userId){
                params.JgAccount = self.userId;
            }
            //请求服务
            this.$post("/customerservicemanager/job/publish", params, function(result) {
                if (result && result.Success) {
                    self.isClearField = true; //清空field缓存数据
                    let queryParams = {
                        platform: self.platform,
                    };
                    if(self.userType && self.userType==2 && self.userId){
                        queryParams.ut = self.userType;
                        queryParams.uid = self.userId;
                    }
                    self.$router.push({
                        path: "/release/clientJobResult",
                        query: queryParams
                    });
                    // console.log(self.formJob.salaryRange);
                    // console.log(self.formJob.workDays);
                } else {
                    self.$toast(result.Message);
                }
            });
        },

        //自定义返回
        customBack() {
            this.isClearField = true;
            if(this.fromPage==100){
                this.goBackToChat();
            } else {
                this.$router.go(-1);
            }
        },
        //返回聊天窗口Agent
        goBackToChat(){
            dsBridge.call("webviewClose", "");
        },

        //同意发布订单须知
        entryReleaseClientJob() {
            this.closeReleaseClientJobConfirmPanel();
        },
        //关闭发布订单须知面板
        closeReleaseClientJobConfirmPanel() {
            this.isShowReleaseClientJobConfirmPanel = false;
        },

        //提示
        selfAlert(cont, callback, cancelauto, dialogType, cancelBack) {
            let self = this;
            self.alert = {
                cont: cont,
                callback: callback ? callback : false,
                cancelauto: cancelauto ? cancelauto : false,
                dialogType: dialogType ? dialogType : 1,
                cancelBack: cancelBack ? cancelBack : false,
            };
            self.alert = self.$uAlert.show_alert(self.alert);
        },
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/client/release/clientJob.js